'use strict';

exports.__esModule = true;
exports.handleRoutes = handleRoutes;
exports.routeTo = routeTo;
var handler = undefined;

function handleRoutes(callback) {
  if (handler) {
    throw new Error('Only one handler is allowed at a time');
  }

  handler = callback;
}

function routeTo(url) {
  if (!handler) {
    throw new Error('A handler needs to be setup before you can route');
  }

  handler(url);
}